import { SwUtils } from "../utils/swutils";
import { RequestNotificationRequest } from "../models/RequestNotificationRequest";


export class ServiceWorkerSvc {

    public swRegistration: ServiceWorkerRegistration;
    public isPushEnabled: boolean;
    public isSwInitialized: boolean;

    private initPromise: Promise<any>;
    private subscription: RequestNotificationRequest;

    constructor() { }

    public initSw(): Promise<any> {
        if (this.isSwInitialized)
            return new Promise((resolve, reject) => { resolve(); });
        if (!this.initPromise)
            this.initPromise= new Promise((resolve, reject) => {
                this.init(0,resolve, reject);
            });
        return this.initPromise;
    }

    private init(retry, resolve, reject) {
        if (!navigator.serviceWorker) {
            var msg = "Service worker not supported";
            console.log(msg);
            reject(msg);
            return;
        }
        navigator.serviceWorker.getRegistrations().then((swRegistrations) => {
            var swRegistration = swRegistrations && swRegistrations.length ? swRegistrations[0] : undefined;
            if (!swRegistration && retry > 5) {
                resolve();
                return;
            }
            else if (!swRegistration) {
                console.log("retry sw", retry);
                retry++;
                setTimeout(() => { this.init(retry,resolve,reject) }, 500);
                return;
            }
            this.swRegistration = swRegistration;

            if (!swRegistration.pushManager) {
                var msg = "PushManager not supported!";
                console.log(msg);
                resolve(msg);
                return;
            }

            this.isSwInitialized = true;
            swRegistration.pushManager.getSubscription()
                .then((subscription) => {
                    var isSubscribed = !(subscription === null);

                    if (isSubscribed) {
                        console.log('User IS subscribed.');
                        console.log(JSON.stringify(subscription));
                        this.isPushEnabled = true;
                        this.subscription = <any>subscription;
                    } else {
                        console.log('User is NOT subscribed.');
                    }

                    resolve();
                })
        })
    }

    public subscribeUser(): Promise<any> {
        return new Promise((resolve, reject) => {
            var applicationServerKey = SwUtils.urlB64ToUint8Array('BDGV7aOrYThDbFIBNwbbBPYO-kfoqGKkP1qNX8hvjOE2bPhmQLYwCyGe-5g3WdXuc6OBWUok4m4wv9A2KCjyRcY');
            // private key: 'rIr7eQhxsoUhunMH7cNLew_Ey5pmqztgFL_gS022YWc';
            this.swRegistration.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: applicationServerKey
            })
                .then((subscription) => {
                    console.log('User is subscribed.');
                    this.isPushEnabled=true;
                    this.subscription = <any>subscription;
                    this.updateSubscriptionOnServer(subscription);

                    resolve();
                })
                .catch((err) => {
                    console.log('Failed to subscribe the user: ', err);
                    this.isPushEnabled= false;
                    resolve();
                });
        });
    }

    public unsubscribeUser(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.swRegistration.pushManager.getSubscription()
                .then((subscription) => {
                    if (subscription) {
                        return subscription.unsubscribe();
                    }
                })
                .catch((error) => {
                    console.log('Error unsubscribing', error);
                    this.isPushEnabled = true;
                })
                .then(() => {
                    this.updateSubscriptionOnServer(null);
                    this.subscription = undefined;
                    console.log('User is unsubscribed.');
                    this.isPushEnabled = false;
                });
        });
    }

    public updateSubscriptionOnServer(subscription) {
        //We should store the key at the server, so it can send notifications, i'm always sending the data with requestNotification os no need to save it on server for testing
        if (subscription) {
            console.log(JSON.stringify(subscription));
        } else {
        }
    }

    public requestANotification(delay: number) {
    }
}


// WEBPACK FOOTER //
// ./services/ServiceWorkerSvc.ts